/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDirtyData = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m14.837 10.495 6.83-6.829-1.415-1.414-6.829 6.829c-2.402-1.77-5.748-1.735-7.871.388l-3.966 3.966 8.897 8.897 3.966-3.966c2.123-2.123 2.159-5.468.388-7.871zm-2.068.654c1.726 1.726 1.747 4.322.265 5.803l-2.551 2.552-1.069-1.069 2.728-2.728-1.414-1.414L8 17.021 6.98 16l2.727-2.729-1.414-1.414-2.728 2.728-1.15-1.15 2.55-2.553c1.482-1.48 4.078-1.46 5.804.266z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDirtyData as DirtyData };
